import { AddEventButton, SearchEvent } from '@features/event';
import { EventList, useFetchEvents } from '@entities/event';
import { SminexClubGroup } from '@features/auth';
import { useEffect, useState } from 'react';
import styles from './events.module.scss';

interface EventsProps {
  groupName?: string | null;
}

export const Events = ({ groupName }: EventsProps) => {
  const { events, fetching, hasMore, loadMore, handleSearchChange } = useFetchEvents();
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearchChange(searchValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue, handleSearchChange]);

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <SearchEvent searchValue={searchValue} setSearchValue={setSearchValue} />
        <AddEventButton isSminexClubGroup={groupName === SminexClubGroup} />
      </div>

      <div className={styles.events} data-testid="events-main-cards">
        <EventList events={events} isLoading={fetching} loadMore={loadMore} hasMore={hasMore} groupName={groupName} />
      </div>
    </div>
  );
};
